<template>
  <div>
    <Nav></Nav>
    <b-container fluid="xl">
      <b-row class="mt-3">
        <b-col>
          <h1>Lealtad → Niveles</h1>
          <p class="text-muted">
            Escalera de niveles de membresía. La equivalencia en pesos usa la tasa de cashback
            ({{ (cashbackRate * 100).toFixed(1) }}%) y {{ pointsPerCurrency }} puntos por peso.
          </p>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button variant="primary" @click="openNew">Nuevo nivel</b-button>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <b-table small striped hover responsive :items="tiers" :fields="fields" :busy="loading">
            <template #cell(color)="data">
              <span :style="{ background: data.item.color || '#ccc', padding: '2px 12px', borderRadius: '4px' }">&nbsp;</span>
            </template>
            <template #cell(equivalencia)="data">
              {{ pesosForTier(data.item) }}
            </template>
            <template #cell(active)="data">
              <b-badge :variant="data.item.active ? 'success' : 'secondary'">{{ data.item.active ? 'Activo' : 'Inactivo' }}</b-badge>
            </template>
            <template #cell(buttons)="data">
              <b-button size="sm" variant="warning" @click="openEdit(data.item)">Editar</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="showModal" :title="editing.id ? 'Editar nivel' : 'Nuevo nivel'" @ok="save" ok-title="Guardar">
      <b-form-group label="Código"><b-form-input v-model="editing.code" :disabled="!!editing.id"></b-form-input></b-form-group>
      <b-form-group label="Nombre"><b-form-input v-model="editing.name"></b-form-input></b-form-group>
      <b-form-group label="Rango (0 = base)"><b-form-input type="number" v-model.number="editing.rank"></b-form-input></b-form-group>
      <b-form-group label="Puntos mínimos en la ventana"><b-form-input type="number" v-model.number="editing.min_points_window"></b-form-input></b-form-group>
      <b-form-group label="Meses de ventana"><b-form-input type="number" v-model.number="editing.window_months"></b-form-input></b-form-group>
      <b-form-group label="Meses de vigencia"><b-form-input type="number" v-model.number="editing.validity_months"></b-form-input></b-form-group>
      <b-form-group label="Color"><b-form-input type="color" v-model="editing.color"></b-form-input></b-form-group>
      <b-form-checkbox v-model="editing.active" switch>Activo</b-form-checkbox>
      <hr />
      <p class="text-muted mb-0">Equivalencia estimada: <strong>{{ pesosForTier(editing) }}</strong> de compra elegible a precio regular.</p>
    </b-modal>
  </div>
</template>

<script>
import Nav from "../../components/Nav.vue";
import loyaltyService from "../../services/loyaltyService";
import featuresService from "../../services/featuresService";

export default {
  name: "niveles",
  components: { Nav },
  data() {
    return {
      tiers: [],
      loading: false,
      cashbackRate: 0.03,
      pointsPerCurrency: 10,
      showModal: false,
      editing: {},
      fields: [
        { key: "rank", label: "Rango" },
        { key: "code", label: "Código" },
        { key: "name", label: "Nombre" },
        { key: "min_points_window", label: "Puntos (ventana)" },
        { key: "equivalencia", label: "≈ Compra" },
        { key: "window_months", label: "Ventana (m)" },
        { key: "validity_months", label: "Vigencia (m)" },
        { key: "color", label: "Color" },
        { key: "active", label: "Estado" },
        { key: "buttons", label: "" },
      ],
    };
  },
  mounted() {
    this.load();
    this.loadRates();
  },
  methods: {
    load() {
      this.loading = true;
      loyaltyService.getTiers()
        .then((res) => { this.tiers = res.data || []; })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"))
        .finally(() => (this.loading = false));
    },
    loadRates() {
      featuresService.getAll().then((res) => {
        const f = res.data && res.data.features && res.data.features["loyalty.points"];
        if (f && f.config) {
          if (f.config.cashback_rate) this.cashbackRate = f.config.cashback_rate;
          if (f.config.points_per_currency) this.pointsPerCurrency = f.config.points_per_currency;
        }
      }).catch(() => {});
    },
    pesosForTier(t) {
      const denom = this.cashbackRate * this.pointsPerCurrency;
      if (!t || !denom) return "-";
      const pesos = (t.min_points_window || 0) / denom;
      return "$" + pesos.toLocaleString("es-MX", { maximumFractionDigits: 0 });
    },
    openNew() {
      this.editing = { code: "", name: "", rank: 0, min_points_window: 0, window_months: 12, validity_months: 12, color: "#cccccc", active: true };
      this.showModal = true;
    },
    openEdit(t) {
      this.editing = { ...t };
      this.showModal = true;
    },
    save(evt) {
      evt.preventDefault();
      const req = this.editing.id
        ? loyaltyService.updateTier(this.editing.id, this.editing)
        : loyaltyService.createTier(this.editing);
      req.then(() => {
        this.showModal = false;
        this.load();
        this.makeToast("Guardado", "Nivel guardado", "success");
      }).catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    errMsg(err) {
      if (err && err.response && err.response.data) {
        return typeof err.response.data === "string" ? err.response.data : (err.response.data.error || JSON.stringify(err.response.data));
      }
      return err && err.message ? err.message : "Error desconocido";
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, { title, variant, autoHideDelay: 5000, appendToast: true });
    },
  },
};
</script>
